import { APPID, APPVERSION } from "../common/globals";
import { BASE_AXIOS } from "../config";

export const apiGetAllQuestions = async (userData) => {
    let form = new FormData();
    form.append("mcid", userData.mcid);
    form.append("key", userData.key);
    form.append("yearvar", userData.yearvar);
    form.append("gamemode", userData.gamemode);
    form.append("areavar", userData.areavar);
 
    if (typeof userData.tracking !== 'undefined') {
        form.append("tracking", 1);
        form.append("pathname", userData.tracking.pathname);
        form.append("pagevia", userData.tracking.pagevia);
        form.append("action", userData.tracking.action);
        form.append("os", userData.tracking.os);
        form.append("ua", userData.tracking.ua);
        form.append("appid", APPID);
        form.append("appversion", APPVERSION);
    } 
    
    try {
        const getAllQuestionsResponse = await BASE_AXIOS().request({
            method: "POST",
            params: {
                method: "getallquestions"
            },
            data: form
        });
        
        return getAllQuestionsResponse.data[0];
    } catch (error) { 
        throw error;
    }
};